<span
  *ngFor="let tag of getFilteredTags()"
  class="badge"
  [ngClass]="getColourClass(tag.colour)"
  style="margin-right: 5px"
  id="badge_{{ tag.id }}"
>
  {{ generateTagName(tag) }}
</span>
